export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7b1dae06feae7a8435f81fccd0f9f165af9ff950&name=fetchTypeahead!'